import React, { createContext, useContext, useEffect, useState } from "react";

const LOCAL_STORAGE_KEY = "pocketpedia-specialism";

// Add new codes and names here as needed
export const specialismCodeMap: Record<string, string> = {
  INT: "Internegeneeskunde",
  OHK: "Oogheelkunde",
  // e.g. DERM: "Dermatologie",
  // e.g. CARD: "Cardiologie",
};

export const specialismCollectionMap: Record<string, string> = {
  INT: "articles",
  OHK: "articles_ohk",
  // e.g. DERM: "articles_derm",
  // e.g. CARD: "articles_cardio",
};

export type SpecialismCode = keyof typeof specialismCodeMap;
export type Specialism = typeof specialismCodeMap[SpecialismCode];

interface SpecialismContextType {
  specialismCode: SpecialismCode;
  specialism: Specialism;
  setSpecialismCode: (code: SpecialismCode) => void;
}

const defaultCode: SpecialismCode = "INT";

const SpecialismContext = createContext<SpecialismContextType>({
  specialismCode: defaultCode,
  specialism: specialismCodeMap[defaultCode],
  setSpecialismCode: () => {},
});

export const useSpecialism = () => useContext(SpecialismContext);

export const SpecialismProvider: React.FC<{ children: React.ReactNode }> = ({ children }) => {
  const [specialismCode, setSpecialismCodeState] = useState<SpecialismCode>(defaultCode);

  useEffect(() => {
    const saved = localStorage.getItem(LOCAL_STORAGE_KEY);
    if (saved && specialismCodeMap[saved]) {
      setSpecialismCodeState(saved as SpecialismCode);
    }
  }, []);

  const setSpecialismCode = (code: SpecialismCode) => {
    setSpecialismCodeState(code);
    localStorage.setItem(LOCAL_STORAGE_KEY, code);
  };

  const specialism = specialismCodeMap[specialismCode];

  return (
    <SpecialismContext.Provider value={{ specialismCode, specialism, setSpecialismCode }}>
      {children}
    </SpecialismContext.Provider>
  );
};